import * as React from 'react';
import classNames from 'classnames';
import BaseHeading from '../../common/BaseHeading/BaseHeading.esm.js';
import BaseSectionWithAnalyticsContext from '../../common/BaseSection/BaseSectionWithAnalyticsContext.esm.js';
import { BaseNucleobaseComponent } from '@invitae/nucleobase-core';
import { IconCardSectionContext } from './IconCardSectionContext.esm.js';
import styles from './IconCardSection.module.esm.js';

var IconCardSection = function (_a) {
    var _b;
    var id = _a.id, _c = _a.fields, analyticsEvents = _c.analyticsEvents, body = _c.body, cardSize = _c.cardSize, decorativeShape = _c.decorativeShape, heading = _c.heading, headingAlignment = _c.headingAlignment, internalName = _c.internalName, items = _c.items, theme = _c.theme, footer = _c.footer, dataCy = _a["data-cy"];
    // if there are 5 or 6 items, then we want columns of 3 instead of 4
    var hasThreeColumns = (items === null || items === void 0 ? void 0 : items.length) === 5 || (items === null || items === void 0 ? void 0 : items.length) === 6;
    var itemsClassNames = classNames(styles.items, (_b = {},
        _b[styles.hasThreeColumns] = hasThreeColumns,
        _b[styles.centered] = headingAlignment === 'center',
        _b[styles.itemsMini] = cardSize === 'mini',
        _b));
    return (React.createElement(BaseSectionWithAnalyticsContext, { analyticsEvents: analyticsEvents, className: classNames(styles[theme], styles.root), "data-cy": dataCy, id: id, sectionName: internalName },
        decorativeShape && React.createElement(BaseNucleobaseComponent, { source: decorativeShape }),
        heading && React.createElement(BaseHeading, { body: body, heading: heading, headingAlignment: headingAlignment }),
        React.createElement("div", { className: "nv-container" },
            React.createElement("ul", { className: itemsClassNames },
                React.createElement(IconCardSectionContext.Provider, { value: {
                        cardSize: cardSize,
                    } }, items === null || items === void 0 ? void 0 : items.map(function (item) { return (React.createElement(BaseNucleobaseComponent, { key: item.sys.id, source: item })); })))),
        footer && React.createElement(BaseNucleobaseComponent, { source: footer })));
};

export { IconCardSection as default };
//# sourceMappingURL=IconCardSection.esm.js.map
